export default __webpack_public_path__ + "static/media/lightbulb.d152fdb2.svg";